export default {
    // https://canyin.hulianzaowu.top/store/#/
    // 账号：dianpu1
    // 密码：abc123456
    title: '餐饮',
    baserUrl: 'https://wxapplets.puhuijishu.top',// 小程序上传域名
    wsUrl: 'wss://aidachu-aiko.com:6001',
    // wsUrl:'wss://cy.gongzuobaogao.cn:6001',
    // wsUrl:`wss://${location.hostname}:6001`,
    // ossUrl: 'http://192.168.1.199:9091', // oss上传域名
    // ossUrl: 'https://oss.hulianzaowu.top', // oss上传线上域名
    // apiUrl:'https://cy.gongzuobaogao.cn', // 测试域名
    // apiUrl: 'https://canyin.hlzw.top', // 测试
    // apiUrl: 'https://canyin.hulianzaowu.top', // 线上域名
    apiUrl: 'https://aidachu-aiko.com', // 艾大厨

    // apiUrl:'http://127.0.0.1:8000'
    // apiUrl: 'http://meal.scgdzy.com.cn',
    // apiUrl:'http://www.cy.com',
    // apiUrl: 'http://192.168.1.199:90', // 本地域名
    // apiUrl : `${location.origin}` // 自动获取域名
}